import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { useRef, useState } from "react";
import { Checkbox } from '@material-ui/core';
import { LinearProgress } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function NestedGrid() {
  const classes = useStyles();
  const prefix=useRef()
  const content=useRef()
  const columnRefs=useRef([])
  const suffix=useRef()
  const tooneline=useRef()
  const wynik=useRef()
  const deletelastcomma=useRef()
  const singlerow=useRef()
  var Prefix;
  var Suffix;
  var Content;
  const [lookups,setlookups] = useState()
  var Domains;
	var ToOneLine = 0;
  const [counter, setcounter] = useState(0);
  const [columns, setColumns] = useState([{ id: 1, type: "content" }]);
  const nextColumnId = useRef(2);
  var sr;

  const getColumnInputs = () => {
    return columnRefs.current.slice(0, columns.length);
  };

  const getContentInputs = () => {
    const inputs = getColumnInputs();
    return inputs
      .map((input, index) => (columns[index] && columns[index].type === "content" ? input : null))
      .filter(Boolean);
  };

  const addContentColumn = () => {
    setColumns((current) => [
      ...current,
      { id: nextColumnId.current++, type: "content" },
    ]);
  };

  const addSeparatorColumn = () => {
    setColumns((current) => [
      ...current,
      { id: nextColumnId.current++, type: "separator" },
    ]);
  };

  const removeLastColumn = () => {
    setColumns((current) => {
      if(current.length === 1)
      {
        return current;
      }
      const next = current.slice(0, -1);
      const contentCount = next.filter((column) => column.type === "content").length;
      if(contentCount === 0)
      {
        return current;
      }
      columnRefs.current = columnRefs.current.slice(0, next.length);
      return next;
    });
  };

{/*
  useEffect(() => {
    fetch('https://mobileappscrapper.herokuapp.com/getdb/TextMerger')
    .then(response => response.json())
    .then(data => setdata(data));

  })
  useEffect(() => {
    const interval = setInterval(() => {
      fetch('https://mobileappscrapper.herokuapp.com/getdb/TextMerger')
      .then(response => response.json())
      .then(data => setdata(data));
      console.log(lookups)
      
    
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  function setdata(data)
  {
    setlookups(data);
  }
*/}

function start(counter){
  //currentElement = 0;
  if(counter < sr.length){
    Show(counter);
    setcounter(counter++)
    setTimeout(function(){
      //FillTable(counter)
      start(counter);
    }, 1);
  }
  if(counter >= sr.length)
  {
    setcounter(0);
    prefix.current.value = Prefix;
    content.current.value = Content;
    suffix.current.value = Suffix;
  }
}

  function Merge()
  {
    setcounter(0);
    Prefix=prefix.current.value;
    Suffix=suffix.current.value;
    Content=content.current.value;
    sr = Content.split(/\n|,/g);
    if(tooneline.current.checked == true)
    {
      ToOneLine = 1;
    }
    else
    {
      ToOneLine = 0;
    }
   
    start(counter);
  }
  const Merge2 = async () =>
  {
    setcounter(1);
    if(tooneline.current.checked == true)
    {
      ToOneLine = 1;
    }
    else
    {
      ToOneLine = 0;
    }
    Prefix=prefix.current.value;
    Suffix=suffix.current.value;
    Content=content.current.value;
    const columnInputs = getColumnInputs();

    if(columns.length > 1)
    {
      const columnLines = columnInputs.map((input) => (input ? input.value : "").split("\n"));
      const rowCount = Math.max(0, ...columnLines.map((column) => column.length));
      const rows = [];
      for(let i = 0; i < rowCount; i++)
      {
        const parts = columnLines.map((column) => (column[i] !== undefined ? column[i] : ""));
        rows.push(parts.join(""));
      }
      if(rows.length === 0)
      {
        rows.push("");
      }
      if(deletelastcomma.current.checked == true)
      {
        const lastIndex = rows.length - 1;
        rows[lastIndex] = rows[lastIndex].replace(/,\s*$/, "");
      }
      let output = rows.map((row) => Prefix + row + Suffix).join(ToOneLine === 1 ? " " : "\n");
      if(deletelastcomma.current.checked == true)
      {
        output = output.replace(/,\s*$/, "");
      }
      wynik.current.innerText = output;
      setcounter(0);
      prefix.current.value = Prefix;
      content.current.value = Content;
      suffix.current.value = Suffix;
      return;
    }

    var ContentArr = Content.split("\n")

    if(singlerow.current && singlerow.current.checked == true)
    {
      const rows = [];
      let buffer = [];
      for(let i = 0; i < ContentArr.length; i++)
      {
        const line = ContentArr[i];
        if(line.trim() === "")
        {
          if(buffer.length > 0)
          {
            rows.push(buffer.join(""));
            buffer = [];
          }
          continue;
        }
        buffer.push(line);
      }
      if(buffer.length > 0)
      {
        rows.push(buffer.join(""));
      }
      if(rows.length === 0)
      {
        rows.push("");
      }
      if(deletelastcomma.current.checked == true)
      {
        const lastIndex = rows.length - 1;
        rows[lastIndex] = rows[lastIndex].replace(/,\s*$/, "");
      }
      let output = rows.map((row) => Prefix + row + Suffix).join("\n");
      if(deletelastcomma.current.checked == true)
      {
        output = output.replace(/,\s*$/, "");
      }
      wynik.current.innerText = output;
      setcounter(0);
      prefix.current.value = Prefix;
      content.current.value = Content;
      suffix.current.value = Suffix;
      return;
    }

    const response = await fetch('https://mobileappscrapper.herokuapp.com/textmerger/', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"prefix": Prefix, "text": ContentArr, "suffix": Suffix})
      })
    var merged = await response.json();
    if(deletelastcomma.current.checked == true)
    {
      try
      {
        merged.Result[merged.Result.length-1] = merged.Result[merged.Result.length-1].replace(',', '');
      }
      catch
      {

      }
      

    }
    if(ToOneLine === 1)
    {
      wynik.current.innerText = merged.Result.map(x => x).join(" ")
      setcounter(0);
      prefix.current.value = Prefix;
      content.current.value = Content;
      suffix.current.value = Suffix;
    }
    if(ToOneLine === 0)
    {
      /*
      for(let element in merged.Result)
      {
        wynik.current.innerText += merged.Result[element] + "\n";
      }
      */
     wynik.current.innerText = merged.Result.map(x => x + "\n").join(" ")
      setcounter(0);
      prefix.current.value = Prefix;
      content.current.value = Content;
      suffix.current.value = Suffix;
    }
   
  }

  function LoadSingleRowExample()
  {
    setColumns([{ id: 1, type: "content" }]);
    nextColumnId.current = 2;
    columnRefs.current = columnRefs.current.slice(0, 1);
    if(prefix.current) prefix.current.value = "('";
    if(suffix.current) suffix.current.value = "'),";
    if(content.current)
    {
      content.current.value = "abc.com,\nNULL,\nabc.com\n\ndef.com,\nNULL,\ndef.com";
    }
    if(singlerow.current) singlerow.current.checked = true;
    if(deletelastcomma.current) deletelastcomma.current.checked = true;
    if(tooneline.current) tooneline.current.checked = false;
  }
  function LowercaseContent()
  {
    const inputs = getContentInputs();
    for(let inputIndex = 0; inputIndex < inputs.length; inputIndex++)
    {
      const input = inputs[inputIndex];
      input.value = input.value.toLowerCase();
    }
    wynik.current.innerText = wynik.current.innerText.toLowerCase();
  }
  function Show(counter)
  {

      if(ToOneLine === 1)
      {
        wynik.current.innerText += Prefix + sr[counter] + Suffix;
      }
      if(ToOneLine === 0)
      {
        wynik.current.innerText += Prefix + sr[counter] + Suffix + "\n";
      }
    
        
      
  }
  function Clear()
  {
    wynik.current.innerText = "";
  }
  function Copy()
  {
    copyToClipboard(wynik.current.innerText);
  }
  function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
}
const extractDomain = () =>
{
  const inputs = getContentInputs();
  for(let inputIndex = 0; inputIndex < inputs.length; inputIndex++)
  {
    const input = inputs[inputIndex];
    let contents = input.value.split("\n");
    input.value = "";
    for(let element = 0; element < contents.length; element++)
    {
      contents[element] = contents[element].split("_")[1];
      input.value += contents[element] + "\n";
    }
  }
  
}
  
  function FormRow() {
    const columnSize = Math.max(2, Math.floor(6 / columns.length));
    const firstContentIndex = columns.findIndex((column) => column.type === "content");
    let contentIndex = 0;
    let separatorIndex = 0;
    return (
      <React.Fragment>
        
        <Grid item xs={3}>
        <br></br>
          Prefix
          <TextField variant="outlined" inputRef={prefix} rows={10} fullwidth multiline id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"200px",resize:"vertical"}} className="inline-txtarea"></TextField>
        </Grid>
        {columns.map((column, index) => {
          if(column.type === "content")
          {
            contentIndex += 1;
          }
          else
          {
            separatorIndex += 1;
          }
          const label = column.type === "content"
            ? (contentIndex > 1 ? `Content ${contentIndex}` : "Content")
            : (separatorIndex > 1 ? `Separator ${separatorIndex}` : "Separator");
          return (
          <Grid item xs={columnSize} key={column.id}>
          <br></br>
            {label}
            <TextField variant="outlined" inputRef={(el) => { columnRefs.current[index] = el; if(index === firstContentIndex) { content.current = el; } }} rows={10} fullwidth multiline id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"200px",resize:"vertical"}} className="inline-txtarea"></TextField>
          </Grid>
        )})}
        <Grid item xs={3}>
        <br></br>
          Suffix
          <TextField variant="outlined" inputRef={suffix} rows={10} fullwidth multiline id="tocheck" style={{borderRadius:"10px",textAlign:"center",width:"100%",height:"200px",resize:"vertical"}} className="inline-txtarea"></TextField>
        </Grid>
      </React.Fragment>

    );
  }

  return (
    <div className={classes.root}>
      <div style={{textAlign:"center"}}>
      <Button style={{marginRight:"20px"}} onClick={()=>{prefix.current.value = "'"; suffix.current.value = "',"}} variant="contained" color="secondary">Add Snowflake '' characters</Button>
      <Button style={{marginRight:"20px"}} onClick={()=>{prefix.current.value = "('"; suffix.current.value = "'),"}} variant="contained" color="secondary">Add Snowflake ('') characters</Button>
      <Button style={{marginRight:"20px"}}  onClick={()=>{prefix.current.value = "'%"; suffix.current.value = "',"}} variant="contained" color="secondary">Add Snowflake '%' characters</Button>
      <Button style={{marginRight:"20px"}}  onClick={LowercaseContent} variant="contained" color="secondary">Change to lowercase</Button>
      <Button style={{marginRight:"20px"}}  onClick={()=>{extractDomain()}} variant="contained" color="secondary">Extract domain from site</Button>
      </div>
      <div style={{textAlign:"center", marginBottom:"12px"}}>
      <Button style={{marginRight:"12px"}} onClick={addContentColumn} variant="outlined" color="primary">Add content column</Button>
      <Button style={{marginRight:"12px"}} onClick={addSeparatorColumn} variant="outlined" color="primary">Add separator column</Button>
      <Button style={{marginRight:"12px"}} onClick={removeLastColumn} variant="outlined" color="primary" disabled={columns.length === 1}>Remove last column</Button>
      <br></br>
      <small>When multiple columns are present, rows are merged left to right.</small>
      </div>
     
      <Grid container spacing={1}>
      
        <Grid container item xs={12} spacing={3}>
        
          <FormRow />
        </Grid>

      </Grid>
      <p><br></br> </p>
      <p> </p>
      <p> </p>
      
                  <Checkbox inputRef={tooneline}  color="primary" type="checkbox" id="showresults"></Checkbox>
                  <label htmlFor="showresults">Merge to one line</label><br></br>
                  <Checkbox inputRef={singlerow}  color="primary" type="checkbox" id="singlerow"></Checkbox>
                  <label htmlFor="singlerow">Merge content as single row (blank line = new row)</label>
                  <Button style={{marginLeft:"12px"}} onClick={LoadSingleRowExample} variant="outlined" color="secondary" size="small">Load single-row example</Button><br></br>
                  <small>Combines each block of lines into one row and wraps it with Prefix + Suffix. Use a blank line to separate multiple rows.</small><br></br>
                  <Checkbox inputRef={deletelastcomma}  color="primary" type="checkbox" id="deletelastcomma"></Checkbox>
                  <label htmlFor="deletelastcomma">Delete last comma</label><br></br>
      <Button variant="contained" color="primary" onClick={Merge2} >Merge</Button><span>  </span>
      <Button color="primary" variant="outlined" onClick={Clear}>Clear result</Button><span></span>
      <Button color="primary" variant="outlined" onClick={Copy}>Copy</Button>

      {(() => {
               
        if (counter > 0) {
          
          return (
            <div>
              <label>Merging...</label>
            <LinearProgress label="Merging" style={{width:"19.5%", height:"10px"}}></LinearProgress>
           </div>
            )
          }
          else
          {
            return
            (
             <></>
            )
          } 
        })()}

  
      <Grid>
        <div>
        <br></br>
        <br></br>
        <div ref={wynik}>

        </div>
        </div>
      </Grid>
    </div>

  );
}
